module.exports = __webpack_public_path__ + "img/facebook-logo.425fc922.svg";